import styled from 'styled-components';

export const FeedPublication = styled.div`
  border-radius: 25px;
  background: ${({ theme }) => theme.colors.background_white};
  box-shadow: 0px 1px 9px #00000029;
  padding: 10px 20px 10px 20px;
  margin: 0 5px 0 5px;
  position: relative;
  .feed-header {
    .feed-text {
      border: none;
      height: 100px;
      width: 100% !important;
      resize: none;
      font-family: 'Futura PT' !important;
      color: #00000029;
      font-size: 15px;
    }

    .feed-text:focus {
      color: ${({ theme }) => theme.colors.text_gray};
      box-shadow: 0 0 0 0;
      outline: 0;
    }

    .feed-text::placeholder {
      color: ${({ theme }) => theme.colors.text};
      font-size: 17px;
    }

    .feed-text-error::placeholder {
      color: ${({ theme }) => theme.colors.error_500};
      font-size: 17px;
    }

    .containerAttachment {
      display: flex;
    }
  }

  .feed-action {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid ${({ theme }) => theme.colors.gray_200};
    padding-top: 0.5rem;

    .action {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    .progress {
      margin-left: 5px;
      flex: 1 1 auto;
    }
  }
  .containerEmojiPicker {
    position: absolute;
    z-index: 1;
  }
  @media (max-width: 400px) {
    .feed-header .feed-text {
      height: 50px;
    }
  }

  @media (max-width: 310px) {
    .feed-action {
      flex-direction: column;

      .action {
        display: flex;
        justify-content: center;
      }

      .publication {
        width: 100% !important;
      }
    }
  }
`;
